import { Component, OnInit } from '@angular/core';
import { CardInfoDetailV2Component } from '@commons/card-info-detail-v2/card-info-detail-v2.component';

@Component({
    selector: 'parking-disney',
    templateUrl: './parking.component.html',
    styleUrls: ['./parking.component.scss'],
    standalone: true,
    imports: [CardInfoDetailV2Component],
})
export class ParkingDisneyComponent implements OnInit {
  constructor() {}
  ngOnInit() {}
}
